<template>
  <div class="padded vh100 flex-center">
    <form id="login-view" class="card form form_login padded-xl w500" @submit.prevent="dologin">
      <!--img src="https://www.persona.agency/api/logo.svg" alt="" class="main-logo"/-->
      <h1 class="display-6">Admin</h1>
      <transition name="fade">
        <alert-bar v-if="msgtext" v-bind:class="msgclass">{{msgtext}}</alert-bar>
      </transition>
      <input-default label="Username" description="Find this in your e-mail" help="hi what is this" v-model="username" capitalizeNone="none"/>
      <input-default label="Password" description="Some text" v-model="password" type="password"/>
      <button class="button button-primary" type="submit">Login</button> <a href="/wachtwoord">Wachtwoord vergeten?</a>
    </form>
  </div>
</template>

<script>
  import InputDefault from '../components/form/InputDefault.vue';
  import AlertBar from '../components/form/Alert.vue';
  import Overview from './Overview.vue';

  import { userService } from '../services/user.service.js';

  export default {
    data: function (){
      return {
        msgtext: '',
        msgclass: 'error',
        username: '',
        password: '',
        submitted: false,
        loading: false,
        returnUrl: '',
        error: ''
      }
    },
    created () {
      // reset login status
      userService.logout();

      // get return url from route parameters or default to '/'
      this.returnUrl = this.$route.query.returnUrl || '/';
    },
    components: {
      InputDefault,
      AlertBar
    },
    methods: {
      dologin: function (event) {

        userService.login(this.username, this.password)
        .then(
          user => this.$router.push(this.returnUrl),
          error => {
            this.msgtext = error;
            this.loading = false;
          }
        );
      }
    }
  }
</script>

<style scoped>
  h1{
    margin-bottom: 1.5rem;
  }
</style>